import * as React from 'react';
import {useRegisterAgenticUIIntent} from 'src/components/agentic-ui';

import {sendMessage} from './ask-ai-store';


export const useHandleAskAiEvents = () => {
  useRegisterAgenticUIIntent('graceai', 'graceai.selectprompt', (intent) => {
    sendMessage(intent.payload.prompt);
  });
};
